import { Instance, types } from 'mobx-state-tree';

import Location from '@common/models/Locations/Location';

const Schedule = types
	.model('Schedule', {
		id: types.identifierNumber,
		name: types.maybe(types.string),
		is_archive: types.maybeNull(types.boolean),
		program_name: types.maybeNull(types.string),
		service_id: types.number,
		system_grade_id: types.maybeNull(types.number),
		location: types.maybeNull(Location),
		counterUntestedLessons: types.optional(types.number, 0),
		is_schedule_program: types.maybeNull(types.boolean),
		is_self_study: types.maybeNull(types.boolean),
	})
	.volatile(() => ({
		loading: false,
	}))
	.views(() => ({}));

export default Schedule;

export interface IScheduleModel extends Instance<typeof Schedule> {}
